var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"any-about-page container this-is-development"},[_c('h2',{staticClass:"big-title"},[_vm._v("開發資訊")]),_c('p',[_vm._v("維護中")])])}]

export { render, staticRenderFns }